// extracted by mini-css-extract-plugin
export default {"whatsanimated":"WhatsAppFlutuante_whatsanimated__0TzUn","tada":"WhatsAppFlutuante_tada__Jb5XX","whatsfloat":"WhatsAppFlutuante_whatsfloat__W8SoK"};